import * as React from 'react';
import styled from 'styled-components';
import { Text } from '@origin-digital/style-guide';
import { PlaceIcon } from '@origin-digital/icon';
var AddressLineContainer = styled.div.withConfig({
  displayName: "AddressLine__AddressLineContainer",
  componentId: "ydjml3-0"
})(["display:flex;flex-direction:row;>:first-child{margin-right:8px;}"]);
export var AddressLine = function AddressLine(_ref) {
  var address = _ref.address;
  return React.createElement(AddressLineContainer, {
    "data-id": "action-bar-address-line"
  }, React.createElement(PlaceIcon, {
    color: "grey48",
    size: 20
  }), React.createElement(Text, {
    color: "grey80",
    size: "xs",
    "data-id": "action-bar-address-line-text"
  }, address));
};